import { ChainId } from '@pancakeswap-libs/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.BSCTESTNET]: '0x726517a9e6A85d0f78290192AcC50158cfB68402', //  TODO: CHANGE THIS
  [ChainId.MAINNET]: '0xc7efb32470dEE601959B15f1f923e017C6A918cA',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
